/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveySubmissionDetails = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        formId: {
    type: 'number',
    isRequired: true,
},
        staffId: {
    type: 'number',
    isRequired: true,
},
        submittedDate: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
        surveyData: {
    type: 'array',
    contains: {
        type: 'StaffSurveyQuestionAndAnswer',
    },
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        updatedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};